import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { MessageService } from 'primeng/api';
import { Chats } from 'src/app/interfaces/chatData';
import { ChatsService } from 'src/app/service/chats.service';
import { LoginService } from 'src/app/service/login.service';
import { MessageData } from 'src/app/service/messageData';
import { MessagesService } from 'src/app/service/messages.service';
import * as Mark from 'mark.js';
import { ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-chat-list',
  templateUrl: './chat-list.component.html',
  styleUrls: ['./chat-list.component.scss'],
  providers: [MessageService]
})
export class ChatListComponent implements OnInit {
  @Input() newConversation: boolean = false;
  @Input() countMessages!: number
  @Input() data: Chats[] | undefined;
  

  private selectedChat: Chats | null = null;
  messages: MessageData[] = []
  rolUsuario: number | undefined
  conversations: any[] = [];
  idSuscription!: number | null;
  datos: string = '';
  idStatus!: number | null
  name!: string | null
  originalData :Chats[] | undefined;
  filteredData: any[] = []
  newChat: boolean = true


  // @Input() searchTerm: string = '';
  // @Output() searchTermChange: EventEmitter<string> = new EventEmitter();
searchTerm: string = ''
showUser: any
  constructor(
    private messageService: MessagesService, private loginService: LoginService, 
    private chatsService: ChatsService, private route: ActivatedRoute,
    private translate: TranslateService
  ) { 
    this.rolUsuario = loginService.chatCrmUser.idRol
    // Establecer idiomas disponibles y el idioma por defecto
    translate.addLangs(['en', 'es']);
    translate.setDefaultLang('es');
  }

  ngOnInit(): void { 
    this.messageService.selectedChat$.subscribe((chat) => {
      this.selectedChat = chat;
    });
    this.messageService.dispositivo$().subscribe(
      async data => {
        this.idSuscription = data == null ? null : data.id;
        if(this.idSuscription){
          this.messageService.messages$.subscribe((messages) =>{
            this.messages = messages
          })
        }
      }

    )
    this.messageService.idStatus$.subscribe((idStatus) => {
      this.idStatus = idStatus;
    });
    this.chatsService.nombresActualizados$.subscribe(data => {
      this.data?.map(value =>{
        if(value.chatId === data?.chatId)
        value.name = data?.nuevoNombre
      })
    });
    this.messageService.obtenerChats().subscribe(value=>{
      this.data = value
      this.data.map(chat=>{
        console.log('fecha', chat.dateTime)
      })
    })
    this.messageService.chatList$.subscribe(chat => {
      if (this.searchTerm !== '') {
        this.data = chat
      }      
    });
    this.messageService.searchTerm$.subscribe((searchTerm) => {
      this.searchTerm = searchTerm;
    });
    this.messageService.showUser$.subscribe(value=>{
      this.showUser = value
    })
    // Obtener el parámetro 'lang' de la URL
    this.route.queryParams.subscribe(params => {
      const lang = params['lang'];
      if (lang) {
        this.translate.use(lang);
      } else {
        this.translate.use('es'); // Idioma por defecto
      }
    });
  }

  generateIconAndText(data: any) {
      return data.text ? data.text : data.lastMessage !== '' ? data.lastMessage : '<i class="material-icons">attach_file</i> Archivo';
  }

  async chatClicked(chat: Chats) {
    this.messageService.setSelectedChat(chat);
    this.data?.forEach(value =>{
      if(value.chatId === chat.chatId){
        value.countMessages = null;
      }
    })

    if (this.searchTerm !== '') {
      this.messageService.updateSearchTerm(this.searchTerm);
    }

    if (this.idSuscription != null) {
      const chatIdSelected = this.selectedChat?.chatId;
      this.establecerChatLeido(this.idSuscription, chatIdSelected);

      if (chat.page !== null && chat.page !== undefined) {
        this.messageService.setPage(chat.page);
        this.messageService.setMessageCount(chat.messageCount);
        const getMessagesPage = await this.messageService.getMessages
          (chatIdSelected, this.idSuscription, chat.page, 20);
        this.messages = getMessagesPage.data;
      } else {
        const getMessagesPage = await this.messageService.getMessages
          (chatIdSelected, this.idSuscription, 0, 20);
        this.messages = getMessagesPage.data;
      }
    }

    chat.newConversation = false
    this.messageService.setShowUser(chat.idUser)
    // Pasar los mensajes al componente MessageScreenComponent
    this.messageService.setMessages(this.messages);
    this.messageService.infoContacto(this.datos);
  }
  
  private establecerChatLeido(idSuscription: number, chatId: string){
    this.messageService.establecerChatLeido(idSuscription, chatId)
    .then(value => {})
    .catch(error => { console.error("Error actualizar leido chat", error)});
  }

  formatDate(timestamp: number): string {
    const date = new Date(timestamp * 1000); 
    const day = date.getDate().toString().padStart(2, '0');
    const month = (date.getMonth() + 1).toString().padStart(2, '0'); 
    const year = date.getFullYear();
    const hours = date.getHours().toString().padStart(2, '0');
    const minutes = date.getMinutes().toString().padStart(2, '0');
    const seconds = date.getSeconds().toString().padStart(2, '0');
  
    return `${day}/${month}/${year} ${hours}:${minutes}:${seconds}`;
  }
  
  
  highlightSearchTerm(text: string, searchTerm: string): string {
    if (!searchTerm || !text) {
      return text;
    }
  
    // Crear un elemento HTML temporal para usar "mark.js"
    const tempElement = document.createElement('div');
    tempElement.innerHTML = text;
  
    if(this.searchTerm !== ''){
      // Resaltar el término de búsqueda utilizando "mark.js"
      const markInstance = new Mark(tempElement);
      markInstance.mark(searchTerm);
    }else{
      
    }
    
    // this.highlightSearchTermInMessage(text, searchTerm)
  
    // Devolver el contenido resaltado como HTML
    return tempElement.innerHTML;
  }  


  
}
